<div *ngIf="regions.length > 0">
  <div>
    <label for="region" i18n>Regija</label>
    <select id="region" [(ngModel)]="selectedRegion" (change)="onRegionChange($event)"
            [ngClass]="{ 'input-error': !selectedRegion }">
      <option *ngFor="let region of regions" [value]="region">{{ displayName(region) }}</option>
    </select>
  </div>

  <div [hidden]="!selectedRegion">
    <label for="city" i18n>Občina</label>
    <select id="city" [(ngModel)]="selectedCity" (change)="onCityChange($event)"
            [ngClass]="{ 'input-error': !selectedCity }"
            [disabled]="!selectedRegion">
      <option *ngFor="let city of cities" [value]="city">{{ displayName(city) }}</option>
    </select>
  </div>

  <div [hidden]="!selectedCity">
    <label for="place" i18n>Kraj</label>
    <select id="place" [(ngModel)]="selectedPlace" (change)="updateControlValue()"
            [ngClass]="{ 'input-error': control.invalid }" [disabled]="!selectedCity">
      <option *ngFor="let place of places" [value]="place.id">{{ place.place }}</option>
    </select>
  </div>

  <app-field-errors [control]="control" [hasToBeTouched]="false"></app-field-errors>
</div>
<div *ngIf="regions.length === 0">
  <div class="mb-4">
    <app-content-shimmer></app-content-shimmer>
  </div>
  <div class="mb-4">
    <app-content-shimmer></app-content-shimmer>
  </div>
  <div class="mb-4">
    <app-content-shimmer></app-content-shimmer>
  </div>
</div>
